module.exports = __webpack_public_path__ + "img/404.c202786a.png";